<template>
    <div class="apps-budgets" :class="{'visible': showModal}">
        <transition name="modal">
            <div class="apps-budget-modal" v-if="showModal">
                <div class="overlay"></div>
                <div class="modal-wrapper">
                    <div class="modal-header">
                        <div class="header-text">Apps Budgets</div>
                        <a class="close-modal" @click="onCloseModal"><img alt="close-modal" src="../../Common/Graph/Images/close.svg" /></a>
                    </div>
                    <div class="modal-body">
                        <div class="filters-container">
                            <div class="filters-container left">
                                <app-dropdown :items="dropdownItems"
                                              :selectedIndex="0"
                                              class="apps-dropdown"
                                              v-model="appFilterItem" />
                            </div>
                            <div class="filters-container right">
                                <input id="reachedBudget" type="checkbox" v-model="onlyReachedBudget" @change="onCheckboxChange"/>
                                <label for="reachedBudget" class="checkbox-label">Show Only Reached Budget</label>
                            </div>
                        </div>
                        <div ref="appsContainer" class="apps-container" :class="{'scroll-active': checkScrollbar()}" @change="checkScrollbar()">
                            <div class="app-row" v-for="app in filteredAppsList" :key="app.pbaNumber">
                                <div class="col-2 budget-col">
                                    <div><percentage-bar :value="app.budgetToUse" :maxValue="app.monthlyBudget" :cost="app.currentCost" :block="app.block"></percentage-bar></div>
                                </div>
                                <div class="col-4 name-col">
                                    <div class="seperator"></div>
                                    <div style="display: flex; flex-wrap: wrap;">
                                        <div class="android-icon"><img alt="android" src="./Images/android.svg" /> </div>
                                        <div class="name-text">
                                            {{app.pbaName}}
                                        </div>
                                        <div class="budget-tooltip">
                                            <img alt="android" src="./Images/info.svg" />
                                            <span class="tooltiptext">
                                                App ID: {{ app.pbaNumber}}
                                                <img class="arrow-img" alt="android" src="./Images/arrow-t.svg" />
                                            </span>
                                        </div>
                                    </div>
                                    <!--<div class="budget-warning" v-if="app.monthlyBudget > 0 && app.budgetToUse <= 0">The new budget is lower than the current spent, the new budget will restart in the next month</div>-->
                                    <div class="budget-warning" v-if="monthlyBudgetWarning === app.pbaNumber">The new budget is lower than the current spent, the new budget will restart in the next month</div>
                                    <div class="budget-error" v-if="monthlyBudgetError === app.pbaNumber">Minimum budget allowed is 1000$</div>
                                </div>
                                <div class="col-2 active-col">
                                    <div class="seperator"></div>
                                    <div style="display: flex;">
                                        <div class="active-text">{{app.activeCampaigns}} Active camapiagns</div>
                                    </div>
                                </div>
                                <div class="col-4 amount-col">
                                    <div class="seperator"></div>
                                    <div :class="{'budget-error': monthlyBudgetError === app.pbaNumber}">
                                        <span class="dolar-sign">$</span>
                                        <span><input class="input" v-init="app.monthlyBudget" @input="onBudgetChanged($event, app)" @keyup="isNumberKey($event)" maxlength="6" placeholder="0" /></span>
                                        <span class="dolar-sign">per month</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer modal-container">
                        <div class="modal-row">
                            <div class="modal-col">
                                <button class="btn btn-info" @click="onCloseModal">Cancel</button>
                            </div>
                            <div class="modal-col">
                                <button class="btn btn-primary" :disabled="changedMonthlyBudgetApps.length < 1 && !monthlyBudgetError" @click="saveMonthlyBudgetApps">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex';
    import PercentageBar from './PercentageBar.vue';
    import Dropdown from '../../Common/Dropdown.vue';

    const storePrefix = "apps_budgets_store";

  export default {
        components: {
          PercentageBar: PercentageBar,
          appDropdown: Dropdown,
        },

        props: {
            appsList: {
                type: Array
            }
        },

        created() {
        },

        

        data() {
            return {
                showModal: false,
                scrollbarActive: false,
                onlyReachedBudget: false,
                dropdownItems: [
                    {
                        name: 'By Urgency',
                        id: 1
                    },
                    {
                        name: 'From High To Low',
                        id: 2
                    },
                    {
                        name: 'From Low To High',
                        id: 3
                    },
                ],
                appFilterItem: {id: 1},
                changedMonthlyBudgetApps: [],
                monthlyBudgetError: '',
                monthlyBudgetWarning: '',
            }
        },

        methods: {

            ...mapMutations({
                'setAppsListWithCampaigns': `${storePrefix}setAppsListWithCampaigns`,
            }),
            
            ...mapActions([
                'getAppsWithActiveCampaigns',
                'saveAppsMonthlyBudget',
            ]),

            filterReachedBudget(appsList) {
                return appsList.filter((app) => !this.onlyReachedBudget || app.monthlyBudget > 0 && app.block);
            },

            sortByActiveCampaigns(appsList) {
                if (navigator.userAgent.indexOf("Firefox") > 0) {
                    // return appsList.sort((a, b) => (b.activeCampaigns === 0) - (a.activeCampaigns === 0) || b.activeCampaigns - a.activeCampaigns)
                    return appsList.sort(function (a, b) {
                        return b.activeCampaigns > a.activeCampaigns ? -1 : 1;
                    });
                } else {
                    return appsList.sort((a, b) => (+b.activeCampaigns) - (+a.activeCampaigns));
                }
            },

            sortAppsList(appsList) {
                if (!this.appFilterItem) { return appsList }
                switch (this.appFilterItem.id) {
                    case 1:
                        return appsList.sort((a, b) => {
                            if (a.monthlyBudget === 0) return 1;        //Return 1 so that b goes first
                            if (b.monthlyBudget === 0) return -1;
                            const aPercentage = (100 / a.monthlyBudget) * a.budgetToUse;
                            const bPercentage = (100 / b.monthlyBudget) * b.budgetToUse;
                            return aPercentage - bPercentage;
                        });
                    case 2:
                        if (navigator.userAgent.indexOf("Firefox") > 0) {
                            return appsList.sort((a, b) => {
                                const aBudget = a.monthlyBudget || 0;
                                const bBudget = b.monthlyBudget || 0;
                                if (aBudget === 0) return 1;
                                if (bBudget === 0) return -1;
                                return bBudget - aBudget;
                            });
                        } else {
                            return appsList.sort((a, b) => (a.monthlyBudget === 0) - (b.monthlyBudget === 0) || b.monthlyBudget - a.monthlyBudget);
                        }
                    case 3:
                        return appsList.sort((a, b) => {
                            const aBudget = a.monthlyBudget || 0;
                            const bBudget = b.monthlyBudget || 0;
                            if (aBudget === 0) return 1;
                            if (bBudget === 0) return -1;
                            return aBudget - bBudget;
                            const amonthlyBudget = a.monthlyBudget || 0;
                            const bmonthlyBudget = b.monthlyBudget || 0;
                            return bmonthlyBudget === 0 && amonthlyBudget === 0 ? 0 : bmonthlyBudget > amonthlyBudget ? -1 : 1;
                        });
                        // return appsList.sort((a, b) => (a.monthlyBudget === 0) - (b.monthlyBudget === 0) || a.monthlyBudget - b.monthlyBudget);
                }
            },

            onOpenModal() {
                this.showModal = true;
                this.monthlyBudgetError = '';
                this.monthlyBudgetWarning = '';
                this.changedMonthlyBudgetApps = [];
                this.checkScrollbar();
                document.body.classList.add('modal-overlay-on');
                setTimeout(() => {
                    this.setAppsListWithCampaigns();
                    this.calcTooltipLeft();
                });
            },

            onCloseModal() {
                document.body.classList.remove('modal-overlay-on');
                this.monthlyBudgetError = '';
                this.monthlyBudgetWarning = '';
                this.changedMonthlyBudgetApps = [];
                this.showModal = false;
            },

            onBudgetChanged(e, app) {
                this.monthlyBudgetError = '';
                this.monthlyBudgetWarning = '';
                const x = e.target.value.replace(/\D/g, '');
                e.target.value = x;
                if (+x !== 0 && +x < 1000) {
                    const idx = this.changedMonthlyBudgetApps.findIndex(a => a.pbaNumber === app.pbaNumber);
                    this.changedMonthlyBudgetApps.splice(idx, 1);
                    this.monthlyBudgetError = app.pbaNumber;
                    return 
                } else if (+x < app.budgetToUse) {
                    this.monthlyBudgetWarning = app.pbaNumber;
                }
                const currentApp = {
                    pbaNumber: app.pbaNumber,
                    monthlyBudget: e.target.value,
                };
                this.changedMonthlyBudgetApps.push(currentApp);
            },

            saveMonthlyBudgetApps() {
                if (this.monthlyBudgetError) {
                    document.querySelectorAll('.budget-error .input')[0].focus();
                    return;
                }
                this.saveAppsMonthlyBudget(this.changedMonthlyBudgetApps)
                    .then((res) => {
                        this.showModal = false;
                    })
                    .catch((er) => {
                        // do something on error
                    });;
            },

            checkScrollbar() {
                // debugger
                const element = this.$refs.appsContainer;
                this.scrollbarActive = element && element.clientHeight < element.scrollHeight;
                return this.scrollbarActive;
            },

            onCheckboxChange() {
                setTimeout(() => {
                    this.checkScrollbar();
                    this.calcTooltipLeft();
                });
            },

            isNumberKey(e) {
                const x = e.target.value.replace(/\D/g, '');
                e.target.value = x;
            },

            calcTooltipLeft() {
                let tooltipArr = document.querySelectorAll('.budget-tooltip');
                let namesArr = document.querySelectorAll('.name-text');
                namesArr.forEach((n, i) => {
                    const nWidth = n.clientWidth;
                    tooltipArr[i].style.left = 40 + nWidth + 'px';
                });
            }
        },

        computed: {

            ...mapGetters([
                'appsBudgetsList',
                'monthlyBudgetLoading',
            ]),

            filteredAppsList() {
                const appsList = [...this.appsBudgetsList];
                return this.sortAppsList(this.sortByActiveCampaigns(this.filterReachedBudget(appsList)));
                // return this.sortAppsList(this.filterReachedBudget(appsList));
            },

        },

        mounted() {
            this.$root.$on('openAppsBudgetsModal', this.onOpenModal);
            this.monthlyBudgetError = '';
            this.monthlyBudgetWarning = '';
        }
  }

</script>

<style lang="scss">
    .modal-overlay-on {
        overflow: hidden !important;
    }
    .apps-budgets {
        position: absolute;
        z-index: 10000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        visibility: hidden;

        &.visible {
            visibility: visible;
        }

        .overlay {
            position: fixed;
            opacity: 0.6;
            z-index: 10;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            mix-blend-mode: darken;
            background-color: #a5a5a5;
            visibility: visible;
            transition: visibility 0s linear 0.3s, opacity 0.3s;
        }

        .modal-wrapper {
            position: fixed;
            z-index: 9999;
            box-shadow: 0 0 1.5em;
            display: flex;
            flex-direction: column;
            padding: 20px;
            width: 692px;
            left: calc(50% - 692px/2);
            top: calc(50% - 395px/2);
            background: #FFFFFF;

            .modal-header {
                display: flex;
                justify-content: space-between;

                .header-text {
                    font-weight: 700;
                    font-size: 18px;
                }

                .close-modal {
                    cursor: pointer;
                }
            }

            .modal-body {
                margin-top: 20px;

                .filters-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .dropdown .item {
                        font-weight: normal;
                    }

                    &.right {
                        input[type=checkbox] {
                            height: 14px
                        }

                        .checkbox-label {
                            color: #666;
                            font-size: 13px;
                        }
                    }
                }

                .apps-container {
                    margin-top: 5px;
                    max-height: 260px;
                    min-height: 260px;
                    overflow-y: auto;
                    overflow-x: hidden;

                    &.scroll-active {
                        margin-right: -20px;
                        padding-right: 10px;
                    }

                    &::-webkit-scrollbar {
                        width: 10px;
                        background: #E5E5E5;

                        &:hover {
                            width: 12px;
                        }
                    }

                    &::-webkit-scrollbar-track {
                        background-color: #fff;
                    }

                    &::-webkit-scrollbar-thumb {
                        -webkit-box-shadow: inset 0 0 10px #D9D9D9;
                    }

                    &::-webkit-scrollbar-thumb:hover {
                        width: 12px;
                    }

                    .app-row {
                        position: relative;
                        display: flex;
                        padding: 15px 0;
                        flex-direction: row;
                        align-items: flex-start;
                        min-height: 32px;
                        background: #F5F5F3;
                        border-radius: 5px;
                        margin-top: 5px;
                        flex-wrap: wrap;
                        align-items: center;

                        &:first-child {
                            margin-top: 0;
                        }

                        .budget-col {
                            display: flex;
                            flex-direction: column;
                            flex: 0 0 calc(20% - 40px);
                            padding: 0 20px;
                            border-left: 1px #d6d6d6;
                            justify-content: center;
                        }

                        .name-col {
                            position: relative;
                            display: flex;
                            padding: 0 20px;
                            flex: 0 0 calc(30% - 40px);
                            flex-direction: column;
                            justify-content: center;
                            align-items: flex-start;

                            .seperator {
                                height: 32px;
                                width: 1px;
                                background: #DADADA;
                                margin-left: -10px;
                                position: absolute;
                                top: calc(50% - 16px);
                                bottom: 10px;
                                left: 10px;
                            }

                            .budget-warning {
                                color: #F88432;
                                margin-top: 5px;
                                font-size: 12px;
                                line-height: 15px;
                                width: 90%;
                                padding-left: 30px;
                            }

                            .budget-error {
                                color: #F1533E;
                                margin-top: 5px;
                                font-size: 12px;
                                line-height: 15px;
                                width: 90%;
                                padding-left: 30px;
                            }

                            .android-icon {
                                width: 20px;
                                height: 20px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            .name-text {
                                font-weight: 700;
                                color: #333333;
                                padding-left: 10px;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                max-width: 130px;
                                word-break: break-all;
                            }

                            .budget-tooltip {
                                position: absolute;
                                display: inline-block;
                                padding-top: 5px;
                                padding-left: 5px;

                                .tooltiptext {
                                    visibility: hidden;
                                    min-width: 80px;
                                    color: #6b6b6b;
                                    text-align: center;
                                    padding: 10px;
                                    position: absolute;
                                    z-index: 1;
                                    background: #FFFFFF;
                                    font-size: 12px;
                                    border: 1px solid #DDDDDD;
                                    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
                                    border-radius: 6px;
                                    top: -10px;
                                    left: 20px;
                                    white-space: nowrap;

                                    .arrow-img {
                                        position: absolute;
                                        left: -8px;
                                        top: 0;
                                        bottom: 0;
                                        margin: auto;
                                        transform: rotate(90deg);
                                        width: 10px;
                                    }
                                }

                                &:hover {
                                    .tooltiptext {
                                        visibility: visible;
                                    }
                                }
                            }
                        }

                        .active-col {
                            display: flex;
                            padding: 0 20px;
                            flex: 0 0 calc(15% - 40px);
                            position: relative;
                            align-items: center;

                            .active-text {
                                color: #666666;
                                font-size: 12px;
                            }

                            .seperator {
                                height: 32px;
                                width: 1px;
                                background: #DADADA;
                                margin-left: -10px;
                                position: absolute;
                                top: calc(50% - 16px);
                                bottom: 5px;
                                left: 10px;
                            }
                        }

                        .amount-col {
                            display: flex;
                            padding: 0 20px;
                            flex: 0 0 calc(34% - 40px);
                            position: relative;
                            align-items: center;

                            .seperator {
                                height: 32px;
                                width: 1px;
                                background: #DADADA;
                                margin-left: -10px;
                                position: absolute;
                                top: calc(50% - 16px);
                                bottom: 10px;
                                left: 10px;
                            }

                            .dolar-sign {
                                color: #666666;
                            }
                        }
                    }

                    .input {
                        width: 80px;
                        padding: 6px 12px;
                        font-size: 14px;
                        line-height: 1.4;
                        background-color: #fff;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        box-shadow: inset 0px 0px 1px 0;
                    }

                    .budget-error {
                        .input {
                            border-color: #F1533E;
                        }
                    }
                }
            }

            .modal-footer {
                width: 100%;
                margin-top: 20px;

                .btn {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 8px 32px;
                    border-radius: 4px;
                    border: none;
                    width: 100%;
                    font-weight: 600;
                }

                .btn-primary {
                    background-color: #46AAF6;
                    color: white;
                }

                .btn-info {
                    background-color: #F5F5F3;
                    color: #767676;
                }
            }
        }

        .modal-container {
            width: 100%;

            .modal-row {
                display: flex;
                flex-wrap: wrap;
                margin-right: -15px;
                margin-left: -15px;

                .modal-col {
                    padding: 0 15px;
                    flex-basis: 0;
                    flex-grow: 1;
                    max-width: 100%;
                }
            }
        }
    }






</style>



// WEBPACK FOOTER //
// src/components/Campaign/AppsBudgets/AppsBudgets.vue